import {css, StyleSheet} from 'aphrodite';
import React from 'react';
import areEqual from 'react-fast-compare';

import * as FilterUtil from 'search/FilterUtil';
import {Filter, QuickFilterKey, QUICK_FILTER_KEY_TO_CONFIGURATION} from 'search/SearchConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {BLUE_POWDER} from 'ui-library/Colors';

export interface QuickFilterButtonProps {
  selectedFilters: Array<Filter>;
  quickFilterKey: QuickFilterKey;
  onAddQuickFilter: (filtersToAdd: Array<Filter>) => void;
  onRemoveQuickFilter: (filterIndexesToRemove: Array<number>) => void;
}

export default function QuickFilterButton(props: QuickFilterButtonProps): JSX.Element {
  const configuration = QUICK_FILTER_KEY_TO_CONFIGURATION[props.quickFilterKey];
  const isSelected = configuration.getFilters().every((expectedFilter) => {
    const currentFiltersForKey = FilterUtil.getFiltersByKey(props.selectedFilters, expectedFilter.key, false);
    return currentFiltersForKey.some((currentFilter) => areEqual(currentFilter, expectedFilter));
  });

  return (
    <Button
      className={css(isSelected && styles.selectedQuickFilter)}
      size={ButtonSize.MEDIUM}
      buttonStyle={ButtonStyle.TERTIARY_BLUE}
      text={configuration.title}
      dataTestAttrs={{
        component: 'QuickFilterButton',
        element: 'root',
        key: props.quickFilterKey,
      }}
      onClick={() => {
        if (isSelected) {
          const indexesToRemove = [];
          for (let idx = 0; idx < props.selectedFilters.length; idx++) {
            const filter = props.selectedFilters[idx];
            if (configuration.getFilters().some((expectedFilter) => areEqual(filter, expectedFilter))) {
              indexesToRemove.push(idx);
            }
          }
          props.onRemoveQuickFilter(indexesToRemove);
        } else {
          props.onAddQuickFilter(configuration.getFilters());
        }
      }}
    />
  );
}

const styles = StyleSheet.create({
  selectedQuickFilter: {
    background: BLUE_POWDER,
  },
});
